import { Endpiont } from 'shared/utils/Endpoints';
import { HTTP_CLIENT } from '../../utils/Interceptor';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { toastMessage } from 'shared/components/toast/Toast';
const getAllColors = async (filter) => {
    const {
        data: { data }
    } = await HTTP_CLIENT.get(Endpiont.color.list + `${filter ? '?' + filter : ''}`);

    return data;
};
const GetAllColors = (filter) => {
    return useQuery(['Colors',filter], () => getAllColors(filter));

};
// ------------------ Add COLOR-------
const addColors = async (payload) => {
    return await HTTP_CLIENT.post(Endpiont.color.add, payload);
};
const AddColorsMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(addColors, {
        onSuccess: (data) => {
            queryClient.invalidateQueries('Colors');
            toastMessage('success', 'Color Added Successfully!');
        },
        onError: (error) => {
            const desc = error?.response?.data?.desc;
            if (desc) {
                toastMessage('error', desc || 'Server Error');
            }
        }
    });
};
// ------------------ Delete Color-------
const deleteColors = async (id) => {
    return await HTTP_CLIENT.delete(Endpiont.color.delete + id);
};
const DeleteColorsMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(deleteColors, {
        onSuccess: (data) => {
            queryClient.invalidateQueries('Colors');
            toastMessage('success', 'Colors Deleted Successfully!');
        },
        onError: (error) => {
            const desc = error?.response?.data?.desc;
            if (desc) {
                toastMessage('error', desc || 'Server Error');
            }
        }
    });
};
// ------------------ Update Color-------
const updateColors = async ({ id, payload }) => {
    return await HTTP_CLIENT.put(Endpiont.color.update + id, payload);
};
const UpdateColorsMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(updateColors, {
        onSuccess: (data) => {
            queryClient.invalidateQueries('Colors');
            toastMessage('success', 'Color Updated Successfully!');
        },
        onError: (error) => {
            const desc = error?.response?.data?.desc || error?.response?.data?.message;
            if (desc) {
                toastMessage('error', desc || 'Server Error');
            }
        }
    });
};

export { GetAllColors, AddColorsMutation, DeleteColorsMutation, UpdateColorsMutation };
